export const transitions = {
  expressive: {
    in: {
      transitionDuration: `250ms`,
      transitionTimingFunction: "cubic-bezier(0.25, 0, 0.25, 1)",
    },
    out: {
      transitionDuration: `250ms`,
      transitionTimingFunction: "cubic-bezier(0, 0.75, 1, 0.75)",
    },
  },
  performance: {
    in: {
      transitionDuration: `130ms`,
      transitionTimingFunction: "cubic-bezier(0.25, 0, 0.25, 1)",
    },
    out: {
      transitionDuration: `130ms`,
      transitionTimingFunction: "cubic-bezier(0, 0.75, 1, 0.75)",
    },
  },
  userTriggeredDelay: "100ms",
  eventTriggeredDelay: "0ms",
};
